<template>
  <div class="car-intro" :class="{'car-intro--mobile': deviceType === 'mobile'}">
    <div class="car-intro__bg">
      <img src="@/assets/intro-bg-pc.png" class="car-intro__bg-img" alt="bg">
      <img :src="bannerSrc" class="car-intro__bg-img" alt="intro placeholder">

      <div class="car-intro__overlay"></div>
    </div>
    <div class="car-intro__container">
      <div class="car-intro__header">
        <h2 class="car-intro__title" v-html="domainConfig?.gallery?.title"></h2>
        <p class="car-intro__subtitle" v-html="domainConfig?.gallery?.content"></p>
      </div>
      <div class="car-intro__features">
        <div v-for="(f, i) in features" :key="i" class="car-intro__feature-card">
          <div class="car-intro__feature-icon-box"><img :src="f.icon"
              class="car-intro__feature-icon"></div>
          <div class="car-intro__feature-info">
            <h3 class="car-intro__feature-title">{{f.title}}</h3>
            <p class="car-intro__feature-desc">{{f.desc}}</p>
          </div>
        </div>
      </div>
      <a :href="getHrefForAll()" class="car-intro__btn"><span>Get Started</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
          fill="none">
          <path
            d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
            fill="white" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CarSellOffer',
  data () {
    return {
      features: [
        { title: 'Categorized Viewing', desc: 'Browse by brand, model, and price.', icon: require('@/assets/sell/1.svg') },
        { title: 'Multidimensional Analysis', desc: 'Detailed insights on performance and safety.', icon: require('@/assets/sell/2.svg') },
        { title: 'Comprehensive Ratings', desc: 'Expert and user-based scores.', icon: require('@/assets/sell/3.svg') },
        { title: 'Latest Vehicle Info', desc: 'Up-to-date market releases.', icon: require('@/assets/sell/4.svg') }
      ]
    };
  },
  computed: {
    ...mapGetters(['deviceType']),
    bannerSrc () {
      return this.deviceType === 'mobile'
        ? '/background/intro/intro-bg-mobile.png'
        : '/background/intro/intro-bg-pc.png';
    }
  },
  methods: { getHrefForAll () { return this.$route.params.channel ? `/${this.$route.params.channel}/car-list` : '/car-list'; } }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';
.car-intro {
	background: #000;
	position: relative;
	padding: rem(60) rem(180) rem(290);
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
	&__bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}
	&__bg-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	&__overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	&__container {
		position: relative;
		z-index: 10;
		display: flex;
		flex-direction: column;
		gap: rem(60);
	}
	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(32);
		font-weight: 800;
		margin: 0 0 rem(16);
	}
	&__subtitle {
		color: rgba(255, 255, 255, 0.7);
		font-size: rem(20);
		font-weight: 200;
		margin: 0;
	}
	&__features {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(20);
	}
	&__feature-card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(24);
		display: flex;
		gap: rem(20);
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);
		transition: all 0.3s ease;
		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}
	&__feature-icon-box {
		width: rem(40);
		height: rem(40);
		background: linear-gradient(180deg, #e2372d 0%, rgba(226, 55, 45, 0) 100%);
		border-radius: rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}
	&__feature-icon {
		width: rem(20);
		height: rem(20);
		filter: brightness(0) invert(1);
	}
	&__feature-title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
		margin: 0;
	}
	&__feature-desc {
		color: rgba(255, 255, 255, 0.6);
		font-size: rem(12);
		margin: 0;
	}
	&__btn {
		background: #e2372d;
		border-radius: rem(12);
		padding: rem(16) rem(32);
		display: inline-flex;
		align-items: center;
		gap: rem(12);
		width: fit-content;
		text-decoration: none;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);
		transition: all 0.3s ease;
		span {
			color: #ffffff;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(16);
			font-weight: 800;
		}
		&:hover {
			opacity: 0.9;
			transform: scale(1.05);
		}
	}
}
.detect_deviece_mobile {
	.car-intro {
		padding: rem(60) rem(16) rem(288);
		&__container {
			gap: rem(40);
		}
		&__features {
			grid-template-columns: 1fr;
			gap: rem(16);
		}
	}
}
</style>